export default [
  {
    component: () => import("@/components/contabilidade/contabilidade-home.vue"),
    name: "contabilidade",
    path: "/contabilidade",
    label: "Contabilidade",
  },
  {
    component: () => import("@/components/contabilidade/docsfiscais/docsfiscais-home.vue"),
    name: "contabilidade.docs",
    path: "/contabilidade/docs",
    label: "Docs. Fiscais",
  },
  {
    component: () => import("@/components/contabilidade/relatorios/relatorios-home.vue"),
    name: "contabilidade.relatorios",
    path: "/contabilidade/relatorios",
    label: "Relatórios",
  },
  {
    component: () => import("@/components/contabilidade/efd/BlocoK.vue"),
    name: "contabilidade.relatorios.bloco-k",
    path: "/contabilidade/relatorios/bloco-k",
    label: "Gerar Bloco K (EFD ICMS/IPI)",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/integracoes-home.vue"),
    name: "contabilidade.integracoes",
    label: "Integrações",
    path: "/contabilidade/integracoes",
  },
  {
    component: () => import("@/components/compras/compras/gerenciar-notas-importadas.vue"),
    name: "contabilidade.docs.nfe",
    path: "/contabilidade/docs/nfe",
    label: "Visualizar Lista de NF-e",
  },
  {
    path: "/contabilidade/docs/nfe/importar",
    name: "contabilidade.docs.nfe.importar",
    label: "Importar NF-e manualmente",
    component: () => import("@/components/compras/compras/importar-NFe.vue"),
  },
  {
    path: "/contabilidade/docs/nfe-industria/:id",
    name: "contabilidade.docs.nfe.importada-industria",
    label: "Visualizar Detalhes de NF-e Importadas (Indústria)",
    component: () => import("@/components/compras/compras/nota-importada-industria.vue"),
  },
  {
    path: "/contabilidade/docs/nfe-comercio/:id",
    name: "contabilidade.docs.nfe.importada",
    label: "Visualizar Detalhes de NF-e Importadas (Comércio)",
    component: () => import("@/components/compras/compras/nota-importada.vue"),
  },
  {
    component: () => import("@/components/logistica/cte/gerenciar-cte-importados.vue"),
    name: "contabilidade.docs.cte",
    path: "/contabilidade/docs/cte",
    label: "Visualizar Lista de CT-e",
  },
  {
    path: "/contabilidade/docs/cte/importar",
    name: "contabilidade.docs.cte.importar",
    label: "Importar CT-e manualmente",
    component: () => import("@/components/logistica/cte/importar-cte.vue"),
  },
  {
    path: "/contabilidade/docs/cte/visualizar/:id",
    name: "contabilidade.docs.cte.show",
    label: "Visualizar Detalhes de CT-e Importada",
    component: () => import("@/components/logistica/cte/cte-importada-show.vue"),
  },
  {
    component: () => import("@/components/compras/compras/servico/gerenciar-nfse-importadas.vue"),
    name: "contabilidade.docs.nfse",
    path: "/contabilidade/docs/nfse",
    label: "Visualizar Lista de NFS-e",
  },
  {
    component: () => import("@/components/compras/compras/servico/nfse-importada-industria.vue"),
    name: "contabilidade.docs.nfse.industria",
    label: "Visualizar Detalhes de NFS-e Importadas",
    path: "/contabilidade/docs/nfse/industria/:id",
  },
  {
    component: () => import("@/components/compras/compras/servico/nova-nfse-manual.vue"),
    name: "contabilidade.docs.nfse.novo",
    label: "Novo Registro Manual de NFS-e",
    path: "/contabilidade/docs/nfse/novo",
  },
  {
    component: () => import("@/components/financeiro/dominio-status.vue"),
    name: "contabilidade.integracoes.dominio-status",
    path: "/contabilidade/integracoes/dominio-status",
    label: "Gerenciar Domínio Sistemas",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/gerenciar-balancete.vue"),
    name: "contabilidade.integracoes.balancete",
    path: "/contabilidade/integracoes/balancete",
    label: "Gerenciar Balancete",
  },
  {
    component: () => import("@/components/contabilidade/relatorios/totais-notas-fiscais.vue"),
    name: "contabilidade.relatorios.totais-notas-fiscais",
    label: "Relatório de Totais de Notas de Saída",
    path: "/contabilidade/relatorios/totais-notas-fiscais",
  },
  {
    component: () => import("@/components/contabilidade/docsfiscais/manifestacao.vue"),
    name: "contabilidade.docs.manifestacao",
    path: "/contabilidade/docs/manifestacao",
    label: "Visualizar Lista de Manifestação",
  },
  {
    component: () => import("@/components/contabilidade/relatorios/totais-notas-entrada.vue"),
    name: "contabilidade.relatorios.totais-notas-entrada",
    path: "/contabilidade/relatorios/totais-notas-entrada",
    label: "Relatório de Totais de Notas de Entrada",
  },
  {
    component: () => import("@/components/contabilidade/relatorios/estoque-competencia.vue"),
    name: "contabilidade.relatorios.estoque-competencia",
    path: "/contabilidade/relatorios/estoque-competencia",
    label: "Relatório de Estoque Contábil por Competência",
  },
  {
    component: () => import("@/components/contabilidade/docsfiscais/exportar-xml.vue"),
    name: "contabilidade.docs.exportar-xml",
    path: "/contabilidade/docs/exportar-xml",
    label: "Exportar XML",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/imobilizados-home.vue"),
    name: "contabilidade.imobilizados",
    path: "/contabilidade/imobilizados",
    label: "Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/gerenciar-imobilizados.vue"),
    name: "contabilidade.imobilizados.gerenciar",
    path: "/contabilidade/imobilizados/gerenciar",
    label: "Gerenciar Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/grupos/gerenciar-grupos-imobilizado.vue"),
    name: "contabilidade.imobilizados.grupos",
    path: "/contabilidade/imobilizados/grupos",
    label: "Grupos de Imobilizados",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/form-imobilizado.vue"),
    name: "contabilidade.imobilizados.novo",
    path: "/contabilidade/imobilizados/novo",
    label: "Novo Imobilizado",
  },
  {
    component: () => import("@/components/contabilidade/imobilizados/form-imobilizado.vue"),
    name: "contabilidade.imobilizados.editar",
    path: "/contabilidade/imobilizados/editar/:id",
    label: "Editar Imobilizado",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/exportacoes-home.vue"),
    name: "contabilidade.integracoes.exportacoes",
    path: "/contabilidade/integracoes/exportacoes",
    label: "Exportações",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/exportar-contas-dominio.vue"),
    name: "contabilidade.integracoes.exportacoes.contas-dominio",
    path: "/contabilidade/integracoes/exportacoes/contas-dominio",
    label: "Exportar Contas - Domínio",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/integracoes-dominio-sistemas.vue"),
    name: "contabilidade.integracoes.dominio-sistemas",
    path: "/contabilidade/integracoes/dominio-sistemas",
    label: "Integrações - Domínio Sistemas",
  },
  {
    component: () => import("@/components/contabilidade/integracoes/PreencherCodigoDominioPendentes.vue"),
    name: "contabilidade.integracoes.dominio-sistemas.pendentes",
    path: "/contabilidade/integracoes/dominio-sistemas/pendentes/:tipo(fornecedores|clientes|contas-bancarias)",
    label: "Códigos Domínio pendentes - Domínio Sistemas",
  },
];
